import { createAppSelector } from '../../app/createAppSelector';
import { getDevices } from '../../api/tradeIn';
import {
    selectIsTradeInSelected,
    selectSelectedTradeInDeviceFromStorage,
    selectSelectedTradeInDeviceId,
    selectSuggestInputValue,
} from './slice';

// #region Devices selectors

/**
 * Selects the Devices query selector
 */
const createTradeInDevicesSelector = createAppSelector(
    [
        state => state,
        selectSuggestInputValue,
    ],
    (_state, suggestInputValue) => getDevices.select(suggestInputValue),
);

/**
 * Selects the Devices query
 */
const selectTradeInDevicesQuery = createAppSelector(
    [
        state => state,
        createTradeInDevicesSelector,
    ],
    (state, selector) => selector(state),
);

/**
 * Selects the `isLoading` state
 */
const selectIsLoading = createAppSelector(
    [
        selectTradeInDevicesQuery,
    ],
    tradeInDevicesQuery =>
        tradeInDevicesQuery.isLoading,
);

/**
 * Selects the `isError` state
 */
const selectIsError = createAppSelector(
    [
        selectTradeInDevicesQuery,
    ],
    tradeInDevicesQuery =>
        tradeInDevicesQuery.isError,
);

/**
 * Selects the array of tradeIn devices
 */
const selectTradeInDevices = createAppSelector(
    [
        selectTradeInDevicesQuery,
    ],
    query => query?.data,
);

/**
 * Selects the array of tradeIn devices
 */
const selectIsDeviceNotFound = createAppSelector(
    [
        selectTradeInDevices,
    ],
    devices => !!devices && devices.length === 0,
);

/**
 * Selects the selected tradeIn device
 */
const selectSelectedTradeInDevice = createAppSelector(
    [
        selectTradeInDevices,
        selectSelectedTradeInDeviceId,
        selectSelectedTradeInDeviceFromStorage,

    ],
    (devices, selectedTradeInDeviceId, selectedTradeInDeviceFromStorage) => {
        if (selectedTradeInDeviceFromStorage) {
            return selectedTradeInDeviceFromStorage;
        }

        if (!devices?.length || !selectedTradeInDeviceId) {
            return null;
        }

        const tradeInDevice = devices
            .find(device => device.id === selectedTradeInDeviceId)
            || null
        ;

        return tradeInDevice;
    },
);

/**
 * Selects the `isTradeIn` status (i. e. the user has tradeIn selected and selected a device)
 */
const selectIsTradeIn = createAppSelector(
    [
        selectIsTradeInSelected,
        selectSelectedTradeInDevice,
    ],
    (isTradeInSelected, selectedTradeInDevice) => isTradeInSelected && !!selectedTradeInDevice,
);

// #endregion

export {
    selectIsLoading,
    selectIsError,
    selectTradeInDevices,
    selectIsDeviceNotFound,
    selectSelectedTradeInDevice,
    selectIsTradeIn,
};
